import React, { memo, useCallback } from 'react';
import clsx from 'clsx';

import { ICONS } from '../../icons';
import Icon from '../../icons/Icon';

import scss from './HideButton.module.scss';

const HideButton = ({ isShow, onToggleVisibility, disabled, label, showLabelOpened }) => {
  const toggleVisibility = useCallback(() => {
    onToggleVisibility(!isShow);
  }, [isShow, onToggleVisibility]);

  return (
    <div className={scss.hideWrapper}>
      <button
        className={clsx(scss.hideButton, !isShow && scss.hideButtonStressed)}
        onClick={toggleVisibility}
        disabled={disabled}>
        {isShow ? (
          <Icon icon={ICONS.EyeCrossed} className={scss.hideButtonIcon} disableCommonColors disableCommonStyles />
        ) : (
          <Icon icon={ICONS.Eye} className={scss.hideButtonIcon} disableCommonColors disableCommonStyles />
        )}
      </button>

      {label ? (
        <span
          className={clsx(
            scss.label,
            !showLabelOpened && isShow && scss.labelHidden,
            showLabelOpened && isShow && scss.labelShowOpened,
            showLabelOpened && !isShow && scss.labelShowHidden,
          )}>
          {label}
        </span>
      ) : null}
    </div>
  );
};

export default memo(HideButton);
